import {type ListBulkOperationsApiArg} from './types';

export function buildBulkOperationsUrl(queryArg: ListBulkOperationsApiArg): string {
  const searchParams = new URLSearchParams();

  searchParams.set('resourceId', queryArg.resourceId);
  queryArg.actionCode?.forEach((code) => searchParams.append('actionCode[]', code));
  queryArg.state?.forEach((state) => searchParams.append('state[]', state));

  if (queryArg.limit !== undefined) {
    searchParams.set('limit', queryArg.limit.toString());
  }
  if (queryArg.offset !== undefined) {
    searchParams.set('offset', queryArg.offset.toString());
  }

  return `/dms/v1/bulk-operation?${searchParams.toString()}`;
}
